import { Component } from '@angular/core';
import { NavController, NavParams, Events } from 'ionic-angular';
import { GlobalVars } from '../../providers/global-vars';
import { ApiCaller } from '../../providers/api-caller';

/*
  Generated class for the NewGuest page.

  See http://ionicframework.com/docs/v2/components/#navigation for more info on
  Ionic pages and navigation.
*/
@Component({
  selector: 'page-new-guest',
  templateUrl: 'new-guest.html'
})
export class NewGuestPage {

    public theGuest:any = {};
    public theDevice:any = {};
  constructor(public navCtrl: NavController, public navParams: NavParams,public events: Events, public apiCaller : ApiCaller, 
              public globalVars : GlobalVars) {
      this.theDevice = navParams.get('theDevice');
      console.log('constructor NewGuestPage theDevice:'+JSON.stringify(this.theDevice));
      
      var today = new Date();
        var dd:any = today.getDate();
        var mm:any = today.getMonth()+1; //January is 0!

        var yyyy = today.getFullYear();
        if(dd<10){
            dd='0'+dd;
        } 
        if(mm<10){
            mm='0'+mm;
        } 
        this.theGuest.from_year = yyyy;
        this.theGuest.from_month = mm;
        this.theGuest.from_day = dd;

      // default tomorrow
            today.setDate(today.getDate() + 1);
            dd = today.getDate();
            mm = today.getMonth()+1; //January is 0!

            yyyy = today.getFullYear();
            if(dd<10){
                dd='0'+dd;
            } 
            if(mm<10){
                mm='0'+mm;
            } 
        this.theGuest.to_year = yyyy;
        this.theGuest.to_month = mm;
        this.theGuest.to_day = dd;
          
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad NewGuestPage');
  }

    eventHandler(keyCode) {
        if (keyCode == 13)
            this.saveGuest();
    }


    saveGuest(){
        
        if (!this.theGuest || !this.theGuest.shareWithName || !this.theGuest.shareWithPhone){
              this.globalVars.showAlert('Missing info','Please enter a name, phone number and dates of stay');
              return;
          }
        
       if (!this.theGuest.from_year || this.theGuest.from_year < 2017 || !this.theGuest.from_month || this.theGuest.from_month < 1 || this.theGuest.from_month >12 || !this.theGuest.from_day || this.theGuest.from_day < 1 || this.theGuest.from_day > 31){
              this.globalVars.showAlert('Missing info','Please enter a valid check in date');
              return;
          }
        this.theGuest.from_date = this.theGuest.from_year+'-'+this.theGuest.from_month+'-'+this.theGuest.from_day;
        
      if (!this.theGuest.to_year || this.theGuest.to_year < 2017 || !this.theGuest.to_month || this.theGuest.to_month < 1 || this.theGuest.to_month >12 || !this.theGuest.to_day || this.theGuest.to_day < 1 || this.theGuest.to_day > 31){
              this.globalVars.showAlert('Missing info','Please enter a valid check out date');
              return;
          }
        this.theGuest.to_date = this.theGuest.to_year+'-'+this.theGuest.to_month+'-'+this.theGuest.to_day;
        
        console.log('saveGuest');
        var requestApp = {};
        (requestApp as any).requestType = 'newGuest';
      
        (requestApp as any).request = this.theGuest;
        (requestApp as any).request.userId = this.globalVars.userSettings.user_id;
        (requestApp as any).request.activationCode = this.globalVars.generalVars.activationCode;
        (requestApp as any).request.deviceUserId = this.theDevice.device_user_id;
        (requestApp as any).request.deviceName = this.theDevice.name;
      
        this.apiCaller.load(requestApp, this.globalVars.msgPleaseWait, true).then(data => {
            if (data && (data as any).result == 200){
             //   this.technicians = (data as any).technicians;
                this.events.publish('refreshGuests',null);
                this.navCtrl.pop();
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/pages/new-guest/new-guest.ts